import React from "react";

import BackButton from "~/screens/Auth/components/BackButton";
import { VISIT_TYPES, VisitType } from "~/services";
import { getVisitTypeTitle } from "~/utils";

export const MainContent = ({
  visitType,
  handleGoBack,
}: {
  visitType: VisitType;
  handleGoBack: () => void;
}) => {
  const visitTitle = getVisitTypeTitle(visitType).toLowerCase();

  const backButtonText =
    visitType === VISIT_TYPES.FOLLOW_UP ? "View all clinicians" : "Back";

  return (
    <section className="space-y-1">
      <BackButton
        variant="violet"
        handleGoBack={handleGoBack}
        text={backButtonText}
      />
      <h1 className="text-indigo font-ivy text-4-5xl w-3/4 font-light leading-tight">
        Let's book your {visitTitle}
      </h1>
    </section>
  );
};
